import { CircleMarker, GeoJSON, useMap } from "react-leaflet";
import { useEffect, useState } from "react";
import { meterToPixel } from "./GeoUtils";
import { FixModeToColor, GPSWithSystemState } from "../config";
import { SystemState } from "@exodigo/exodigo-exodaq-protocols/dist/exodigo/protobuf/exodaq_protocols/system";

export function WalkTrail(props: WalkTrailProps) {
  const map = useMap();
  const [weight, setWeight] = useState(meterToPixel(props.lat, map.getZoom()));

  useEffect(() => {
    setWeight(meterToPixel(props.lat, map.getZoom(), props.trailWidth) * 2);
  }, [props.lat, map, props.trailWidth]);

  return (
    <GeoJSON
      key={JSON.stringify(props.travelCourse) + JSON.stringify(weight)}
      data={props.travelCourse}
      pathOptions={{ weight: weight, opacity: 0.5 }}
    />
  );
}

export function PathHistory(props: PathHistoryProps) {
  const defaultMeters = 0.04;
  const map = useMap();
  const [radius, setRadius] = useState(meterToPixel(props.lat, map.getZoom(), defaultMeters));

  useEffect(() => {
    setRadius(meterToPixel(props.lat, map.getZoom(), defaultMeters));
  }, [props.lat, map]);

  return (
    <>
      {props.travelCourse.map((p, i) => (
        <CircleMarker
          key={i}
          center={[p[0].lat, p[0].lon]}
          radius={radius}
          pathOptions={{
            color: "black",
            fillOpacity: 1,
            fillColor: p[1] !== SystemState.SYSTEM_SCAN_PAUSED ? FixModeToColor[p[0].fixMode] : "red",
            weight: 1.5,
          }}
        />
      ))}
    </>
  );
}

interface WalkTrailProps {
  lat: number;
  trailWidth: number;
  travelCourse: any;
}

interface PathHistoryProps {
  lat: number;
  travelCourse: GPSWithSystemState[];
}
